module.exports = "\r\n<app-renderengine [data]=\"displayElements\">\r\n\r\n</app-renderengine>\r\n"